// extracted by mini-css-extract-plugin
export default {"root":"IconDisputeOrder_root__LAM+O"};